import React from 'react';
import './App.css';
import { BrowserRouter, Routes, Route } from 'react-router-dom';
import { Toaster } from './components/ui/toaster';
import Header from './components/Header';
import Hero from './components/Hero';
import WhyChooseUs from './components/WhyChooseUs';
import Services from './components/Services';
import Pricing from './components/Pricing';
import Testimonials from './components/Testimonials';
import CTA from './components/CTA';
import Contact from './components/Contact';
import Footer from './components/Footer';
import ShopPage from './components/ShopPage';
import ChatWidget from './components/ChatWidget';

const Home = () => (
  <>
    <Header />
    <main>
      <Hero />
      <WhyChooseUs />
      <Services />
      <Pricing />
      <Testimonials />
      <CTA />
      <Contact />
    </main>
    <Footer />
  </>
);

function App() {
  return (
    <div className="App">
      <BrowserRouter>
        <Routes>
          <Route path="/" element={<Home />} />
          <Route path="/shop" element={<ShopPage />} />
        </Routes>
        <ChatWidget />
      </BrowserRouter>
      <Toaster />
    </div>
  );
}

export default App;
